import { graphql, useStaticQuery } from "gatsby"

type PrimaryExtensionType = {
  flatData: {
    id: number
    extension: string
  }
}

type Query = {
  GraphCmsSquidex: {
    findDomainSearchAiPageSingleton: {
      flatData: {
        enabled: boolean
        url: string
        primaryExtensions: PrimaryExtensionType[]
        secondaryExtensions: PrimaryExtensionType[]
      }
    }
  }
}

type Hook = {
  enabled: boolean
  url: string
  primaryExtensions: PrimaryExtensionType[]
  secondaryExtensions: PrimaryExtensionType[]
}

export default function useDomainSearchAiSettingsQuery(): Hook {
  const {
    GraphCmsSquidex: { findDomainSearchAiPageSingleton },
  } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findDomainSearchAiPageSingleton {
          flatData {
            enabled
            url
            primaryExtensions {
              id
              flatData {
                id
                extension
              }
            }
            secondaryExtensions {
              id
              flatData {
                id
                extension
              }
            }
          }
        }
      }
    }
  `)

  return {
    enabled: findDomainSearchAiPageSingleton.flatData.enabled ?? false,
    url: findDomainSearchAiPageSingleton.flatData.url,
    primaryExtensions:
      findDomainSearchAiPageSingleton.flatData.primaryExtensions || [],
    secondaryExtensions:
      findDomainSearchAiPageSingleton.flatData.secondaryExtensions || [],
  }
}
